/* eslint-disable @scandipwa/scandipwa-guidelines/derived-class-names */
import FieldContainer from 'Component/Field';
import { FIELD_TYPE } from 'Component/Field/Field.config';
import PRODUCT_TYPE from 'Component/Product/Product.config';
import ProductWishlistButton from 'Component/ProductWishlistButton';
import {
    Product as SourceProduct
} from 'SourceComponent/Product/Product.component';
import { VALIDATION_INPUT_TYPE_NUMBER } from 'Util/Validator/Config';
/** @namespace Bodypwa/Component/Product/Component */
export class Product extends SourceProduct {
    renderQuantityChanger() {
        const {
            quantity,
            handleInputBlur,
            maxQuantity,
            minQuantity,
            setQuantity,
            inStock,
            product: { type_id }
        } = this.props;

        if (type_id === PRODUCT_TYPE.grouped) {
            return null;
        }

        return (
            <FieldContainer
              type={ FIELD_TYPE.number }
              attr={ {
                  id: 'item_qty',
                  name: 'item_qty',
                  defaultValue: quantity,
                  minQuantity,
                  max: maxQuantity,
                  min: 0
              } }
              validationRule={ {
                  inputType: VALIDATION_INPUT_TYPE_NUMBER.numeric,
                  isRequired: false,
                  range: {
                      min: 0,
                      max: maxQuantity
                  }
              } }
              isDisabled={ !inStock }
              mix={ { block: this.className, elem: 'Qty' } }
              events={ { onChange: setQuantity, onBlur: handleInputBlur } }
              validateOn={ ['onChange'] }
            />
        );
    }

    renderWishlistButton() {
        const { magentoProduct } = this.props;

        if (magentoProduct.length === 0) {
            return null;
        }

        return (
            <ProductWishlistButton
              magentoProduct={ magentoProduct }
              hideWishlistButton
              mix={ {
                  block: this.className,
                  elem: 'WishListButton'
              } }
            />
        );
    }
}

export default Product;
